require('./authorizationsTable.scss');

import PropTypes from 'prop-types';

// @ vendors
import { connect } from 'react-redux';
import React from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
// @ actions
import { expandRow } from 'actions/accountDebits/authorizations';
// @ commons
import { LoadingSection } from 'commonsComponents/loadingSection';
import { i18n } from 'core/i18n';
const { FormattedText, formatText, getLanguage } = i18n;
import { OKButton } from 'commonsComponents/OKButton';
import { OKTableCell } from 'commonsComponents/OKTableCell';
import { OKTableRow } from 'commonsComponents/OKTableRow';
import { LastMovementsTable } from 'commonsComponents/lastMovementsTable';
// @ components
import AuthorizationsTableRow from '../authorizationsTableRow/authorizationsTableRow';
import AuthorizationDetail from '../authorizationDetail/authorizationDetail';
import { EmptyState } from 'commonsComponents/emptyState';
// @ constants
import { ACCOUNT_DEBITS_TABLE_LIMIT } from 'constants/index';
import { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } from 'constants/commonsComponents';
const language = getLanguage();

class AuthorizationsTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            maxDocumentsToSee: ACCOUNT_DEBITS_TABLE_LIMIT
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    handleRowClick = (rowId) => {
        const { expandRow, immAuthorizations, accountId } = this.props;
        const expandedRowId = immAuthorizations.get('expandedRowId');
        expandRow(accountId, (rowId === expandedRowId) ? '' : rowId)
    }

    handleViewMore = () => {
        if (this.props.immAuthorizations.get('byOrder').size > this.state.maxDocumentsToSee) {
            this.setState({
                maxDocumentsToSee: this.state.maxDocumentsToSee + ACCOUNT_DEBITS_TABLE_LIMIT
            })
        }
    }

    renderNotFound = (textKey) => {
        return (
            <div className="account-debits__not-found" >
                <EmptyState primaryText={formatText(textKey)} iconType="noitems-banking"/>
            </div>
        );
    }

    renderTable = () => {
        const { immAuthorizations } = this.props;
        const expandedRowId = immAuthorizations.get('expandedRowId');
        const immAuthorizationsfilteredIds = immAuthorizations.get('filteredIds');
        const immAuthorizationsbyId = immAuthorizations.get('byId');
        const transactionsCount = Math.min(immAuthorizationsfilteredIds.size, this.state.maxDocumentsToSee);
        return(
            <div>
                <LastMovementsTable
                    groupByDate={false}
                    isExpandable={false}
                    columnsCount={5}
                    expandedRowComponent={AuthorizationDetail}
                    expandedRowId={expandedRowId}
                    idFromReducer={true}
                    immTransactionsById={immAuthorizationsbyId}
                    immTransactionsByOrder={immAuthorizationsfilteredIds.take(transactionsCount)}
                    onRowClick={this.handleRowClick}
                    rowComponent={AuthorizationsTableRow}
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true} className="authorizations-table__expand">
                                <span></span>
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="authorizations-table__name">
                                <FormattedText value="accountDebits-emisor" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="authorizations-table__date">
                                <FormattedText value="accountDebits-lastDate" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="authorizations-table__status">
                                <FormattedText value="accountDebits-status" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="authorizations-table__actions">
                                <span></span>
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
                {
                    immAuthorizationsfilteredIds && immAuthorizationsfilteredIds.size > this.state.maxDocumentsToSee &&
                        <OKButton modifier="link-complementary" onClick={this.handleViewMore}>
                            <FormattedText value="authorization-viewMore" />
                        </OKButton>
                }
            </div>
        )
    }

    doesntHaveAuthorizationsAtAllOrError = (immAuthorizations) => {
        return immAuthorizations && (immAuthorizations.getIn(['byId']).size == 0 || immAuthorizations.get('error'));
    }

    doesntHaveAuthorizationsWithTheSelectedFilter = (immAuthorizations) => {
        return immAuthorizations && immAuthorizations.get('filteredIds').size === 0 && immAuthorizations.getIn(['byId']).size > 0;
    }

    hasAuthorizationsToRender = (immAuthorizations) => {
        return immAuthorizations && immAuthorizations.getIn(['byId']).size > 0 && immAuthorizations.get('filteredIds').size !== 0;
    }

    render() {
        const { immAuthorizations } = this.props;

        if (this.hasAuthorizationsToRender(immAuthorizations)) {
            return this.renderTable();
        } else if (this.doesntHaveAuthorizationsAtAllOrError(immAuthorizations) || this.doesntHaveAuthorizationsWithTheSelectedFilter(immAuthorizations)) {
            const textKey = immAuthorizations.get('error') ? 'authorizations-error' : 'authorizations-notFound';
            return this.renderNotFound(textKey);
        } else {
            return <LoadingSection />;
        }
    }
}

AuthorizationsTable.propTypes = {
    expandRow: PropTypes.func,
    expandedRowId: PropTypes.string,
    immAuthorizations: PropTypes.object,
    accountId: PropTypes.string
 };

export default connect(
    (state, ownProps) => ({
        immAuthorizations: state.authorizations.get(ownProps.accountId)
    }),
    {
        expandRow
    }
)(AuthorizationsTable);
